import { isAfter, startOfDay, subYears } from 'date-fns'
import { toDate } from 'util/date/formatDate'

const LIMIT_AGE_TO_SHOW_DECIDUOS = 16

export const getShowDeciduosByAge = (cidadaoDataNascimento: LocalDate, dataReferencia: Date) => {
  const limitDate = subYears(dataReferencia, LIMIT_AGE_TO_SHOW_DECIDUOS)
  return dataReferencia && isAfter(startOfDay(toDate(cidadaoDataNascimento)), startOfDay(limitDate))
}
